import { ArrowDownOutlined, ArrowUpOutlined } from "@ant-design/icons";
import { Card, Col, Row, Statistic } from "antd";

export default function CollectionDetailed({ kpiData }) {
  const cardStyle = {
    height: "100%",
  };

  const statisticStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "24px" }}>
      <Row gutter={[24, 24]}>
        <Col span={8}>
          <Card bordered={true} style={cardStyle}>
            <Statistic
              style={statisticStyle}
              title="Tempo de permanência antes da mudança"
              value={kpiData?.permanence.before_change}
              precision={2}
              suffix="min/dia"
            />
          </Card>
        </Col>
        <Col span={8}>
          <Card bordered={true} style={cardStyle}>
            <Statistic
              style={statisticStyle}
              title="Tempo de permanência após a mudança"
              value={kpiData?.permanence.after_change}
              precision={2}
              suffix="min/dia"
            />
          </Card>
        </Col>
        <Col span={8}>
          <Card bordered={true} style={cardStyle}>
            <Statistic
              style={statisticStyle}
              title="Variação do tempo de permanência"
              value={kpiData?.permanence_variation.percent}
              precision={2}
              suffix="%"
              prefix={
                kpiData?.permanence_variation.color === "red" ? (
                  <ArrowDownOutlined />
                ) : kpiData?.permanence_variation.color === "green" ? (
                  <ArrowUpOutlined />
                ) : null
              }
              valueStyle={{
                color:
                  kpiData?.permanence_variation.color === "red"
                    ? "#cf1322"
                    : kpiData?.permanence_variation.color === "green"
                      ? "#3f8600"
                      : "inherit",
              }}
            />
          </Card>
        </Col>
      </Row>
      <Row gutter={[24, 24]}>
        <Col span={8}>
          <Card bordered={true} style={cardStyle}>
            <Statistic
              style={statisticStyle}
              title="Faturamento antes da mudança"
              value={kpiData?.revenue.before_change}
              precision={2}
              prefix="R$"
              suffix="/dia"
            />
          </Card>
        </Col>
        <Col span={8}>
          <Card bordered={true} style={cardStyle}>
            <Statistic
              style={statisticStyle}
              title="Faturamento após a mudança"
              value={kpiData?.revenue.after_change}
              precision={2}
              prefix="R$"
              suffix="/dia"
            />
          </Card>
        </Col>
        <Col span={8}>
          <Card bordered={true} style={cardStyle}>
            <Statistic
              style={statisticStyle}
              title="Variação do faturamento"
              value={kpiData?.revenue_variation.percent}
              precision={2}
              suffix="%"
              prefix={
                kpiData?.revenue_variation.color === "red" ? (
                  <ArrowDownOutlined />
                ) : kpiData?.revenue_variation.color === "green" ? (
                  <ArrowUpOutlined />
                ) : null
              }
              valueStyle={{
                color:
                  kpiData?.revenue_variation.color === "red"
                    ? "#cf1322"
                    : kpiData?.revenue_variation.color === "green"
                      ? "#3f8600"
                      : "inherit",
              }}
            />
          </Card>
        </Col>
      </Row>
    </div>
  );
}
